import { useMutation } from '@tanstack/react-query';
import { markContentAsSelected } from '../../../core/queries/course';

function useMarkContentAsSelected() {
  const { data, isError, error, isSuccess, isPending, mutate } = useMutation({
    mutationKey: ['mark-content-as-selected'],
    mutationFn: (data: any) =>
      markContentAsSelected(data.courseId, data.programId, data.contentId),
    retry: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    mutate,
  };
}

export { useMarkContentAsSelected };
